import { render, staticRenderFns } from "./HistorialActivacion.vue?vue&type=template&id=57cffa48&lang=pug"
import script from "./HistorialActivacion.vue?vue&type=script&lang=js"
export * from "./HistorialActivacion.vue?vue&type=script&lang=js"
import style0 from "./HistorialActivacion.vue?vue&type=style&index=0&id=57cffa48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports